import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { ContainerState } from './types';

// The initial state of the templates container
export const initialState: ContainerState = {
  inventory: { data: {}, loading: false, error: null },
  compileTemplate: { data: {}, loading: false, error: null },
  uploadFile: { data: {}, loading: false, error: null },
  templates: { data: {}, loading: false, error: null },
  categories: { data: {}, loading: false, error: null },
  subCategories: { data: {}, loading: false, error: null },
  segments: { data: {}, loading: false, error: null },
  algorithm: { data: {}, loading: false, error: null },
};

const generateEmailSlice = createSlice({
  name: 'generateEmailState',
  initialState,
  reducers: {
    requestInventory(state, action) {
      state.inventory.data = {};
      state.inventory.loading = true;
      state.inventory.error = null;
    },
    requestInventorySuccess(state, action: PayloadAction<any>) {
      state.inventory.data = action.payload;
      state.inventory.loading = false;
    },
    requestInventoryError(state, action: PayloadAction<any>) {
      state.inventory.error = action.payload;
      state.inventory.loading = false;
    },
    requestCompileTemplate(state, action) {
      state.compileTemplate.data = {};
      state.compileTemplate.loading = true;
      state.compileTemplate.error = null;
    },
    requestCompileTemplateSuccess(state, action: PayloadAction<any>) {
      state.compileTemplate.data = action.payload;
      state.compileTemplate.loading = false;
    },
    requestCompileTemplateError(state, action: PayloadAction<any>) {
      state.compileTemplate.error = action.payload;
      state.compileTemplate.loading = false;
    },
    requestUploadFile(state, action) {
      state.uploadFile.data = {};
      state.uploadFile.loading = true;
      state.uploadFile.error = null;
    },
    requestUploadFileSuccess(state, action: PayloadAction<any>) {
      state.uploadFile.data = action.payload;
      state.uploadFile.loading = false;
    },
    requestUploadFileError(state, action: PayloadAction<any>) {
      state.uploadFile.error = action.payload;
      state.uploadFile.loading = false;
    },
    requestTemplates(state, action) {
      state.templates.data = {};
      state.templates.loading = true;
      state.templates.error = null;
    },
    requestTemplatesSuccess(state, action: PayloadAction<any>) {
      state.templates.data = action.payload;
      state.templates.loading = false;
    },
    requestTemplatesError(state, action: PayloadAction<any>) {
      state.templates.error = action.payload;
      state.templates.loading = false;
    },
    requestCategories(state, action) {
      state.categories.data = {};
      state.categories.loading = true;
      state.categories.error = null;
    },
    requestCategoriesSuccess(state, action: PayloadAction<any>) {
      state.categories.data = action.payload;
      state.categories.loading = false;
    },
    requestCategoriesError(state, action: PayloadAction<any>) {
      state.categories.error = action.payload;
      state.categories.loading = false;
    },
    requestSubCategories(state, action) {
      state.subCategories.data = {};
      state.subCategories.loading = true;
      state.subCategories.error = null;
    },
    requestSubCategoriesSuccess(state, action: PayloadAction<any>) {
      state.subCategories.data = action.payload;
      state.subCategories.loading = false;
    },
    requestSubCategoriesError(state, action: PayloadAction<any>) {
      state.subCategories.error = action.payload;
      state.subCategories.loading = false;
    },
    requestSegments(state, action) {
      state.segments.data = {};
      state.segments.loading = true;
      state.segments.error = null;
    },
    requestSegmentsSuccess(state, action: PayloadAction<any>) {
      state.segments.data = action.payload;
      state.segments.loading = false;
    },
    requestSegmentsError(state, action: PayloadAction<any>) {
      state.segments.error = action.payload;
      state.segments.loading = false;
    },
    requestAlgorithm(state, action) {
      state.algorithm.data = {};
      state.algorithm.loading = true;
      state.algorithm.error = null;
    },
    requestAlgorithmSuccess(state, action: PayloadAction<any>) {
      state.algorithm.data = action.payload;
      state.algorithm.loading = false;
    },
    requestAlgorithmError(state, action: PayloadAction<any>) {
      state.algorithm.error = action.payload;
      state.algorithm.loading = false;
    },
  },
});

export const {
  actions: generateEmailActions,
  reducer,
  name: sliceKey,
} = generateEmailSlice;
